import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";

import { Headersub } from "../../GenericComponent/HeaderSub/headersub";
import { TableDanhSach } from "./TableDanhSach";
import { SearchBarDesktop } from "./SearchBar/SearchBarDesktop";
import { SearchBarMobile } from "./SearchBar/SearchBarMobile";
import { useSelector, useDispatch } from "react-redux";
import StoreApi from "service/phanQuyenApi";
import { showFormTraGop } from "actions/ThemMoiTraGop";
import { showFormTinChap } from "actions/ThemMoiTinChap";
import { showFormCamDo } from "actions/ThemMoiCamDo";
import { showModalLoaiTaiSan } from "actions/LoaiTaiSan";
import LayoutV2 from "containers/LayoutV2";

export const HopDongChoDuyetPheDuyet = (props) => {
  const initPhanQuyen = {
    quytrinhpheduyet_danhsach: false,
    quytrinhpheduyet_cappheduyet: false,
    quytrinhpheduyet_cauhinhchoduyet: false,
    quytrinhpheduyet_quanlygoivay: false,

    hopdongchoduyet_duyetchoduyet: false,

    hopdongchoduyet_suachoduyet: false,
    hopdongchoduyet_xoachoduyet: false,
    hopdongchoduyet_chitiethopdong: false,
    hopdongchoduyet_chitietkhachhang: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  const dispatch = useDispatch();

  const ShowFormTraGop = (data) => {
    dispatch(showFormTraGop(data));
  };
  const ShowFormTinChap = (data) => {
    dispatch(showFormTinChap(data));
  };
  const ShowFormCamDo = (data) => {
    dispatch(showFormCamDo(data));
  };
  const ShowModalLoaiTaiSan = (data) => {
    dispatch(showModalLoaiTaiSan(data));
  };

  useEffect(() => {
    document.title = "Quản lý chờ duyệt | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
  }, []);

  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenQuyTrinhPheDuyet().then((response) => {
      setPhanQuyen({
        ...phanQuyen,
        quytrinhpheduyet_danhsach: response.data.quytrinhpheduyet_danhsach,
        quytrinhpheduyet_cappheduyet:
          response.data.quytrinhpheduyet_cappheduyet,
        quytrinhpheduyet_cauhinhchoduyet:
          response.data.quytrinhpheduyet_cauhinhchoduyet,
        quytrinhpheduyet_quanlygoivay:
          response.data.quytrinhpheduyet_quanlygoivay,
        hopdongchoduyet: response.data.hopdongchoduyet,
        quytrinhpheduyet_duyetchoduyet:
          response.data.quytrinhpheduyet_duyetchoduyet,
        quytrinhpheduyet_suachoduyet:
          response.data.quytrinhpheduyet_suachoduyet,
        quytrinhpheduyet_xoachoduyet:
          response.data.quytrinhpheduyet_xoachoduyet,
      });
    });
  };
  return (
    <LayoutV2>
      {phanQuyen.quytrinhpheduyet_danhsach && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new mb-1">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          {/* <div className="col-sm-6"> */}
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-cam-do-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">
                            Hợp đồng chờ duyệt phê duyệt
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop />
                  </div>
                </div>
              </div>
            </div>
            <SearchBarMobile />
          </div>
          <TableDanhSach
            quyenDuyet={phanQuyen.quytrinhpheduyet_duyetchoduyet}
            quyenSua={phanQuyen.quytrinhpheduyet_suachoduyet}
            quyenXoa={phanQuyen.quytrinhpheduyet_xoachoduyet}
            showFormTraGop={ShowFormTraGop}
            showFormTinChap={ShowFormTinChap}
            inthuchi={props.inthuchi}
            phanquyen={props.phanquyen}
            showFormCamDo={ShowFormCamDo}
            showModalLoaiTaiSan={ShowModalLoaiTaiSan}
            loaitaisan={props.loaitaisan}
            isDuDungPhiPhatDongLaiTatToan={
              phanQuyen.SuDungPhiPhat_DongLai_TatToan
            }
            SuDungPhiPhat_DongLai_Cham={phanQuyen.SuDungPhiPhat_DongLai_Cham}
            isSuDungCongTacVienNhanVien={phanQuyen.SuDungCongTacVienNhanVien}
            isSuDungTatToanSom={phanQuyen.SuDungTatToanSom}
          />
        </div>
      )}
      {!phanQuyen.quytrinhpheduyet_danhsach && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new mb-1">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          {/* <div className="col-sm-6"> */}
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-cam-do-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">
                            Hợp đồng chờ duyệt phê duyệt
                          </h1>
                          {/* </div> */}
                          {/* <div className="col-sm-6"></div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
